import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importez les fichiers de traduction
import translationEN from './locales/en.json';
import translationFR from './locales/fr.json';

// Configurez la bibliothèque i18next
i18n.use(initReactI18next).init({
  lng: 'en', // Langue par défaut
  fallbackLng: 'en', // Langue de secours
  resources: {
    en: {
      translation: translationEN,
    },
    fr: {
      translation: translationFR,
    },
  },
});

export default i18n;
